export default "__VITE_ASSET__b978cf15__"